<div class="p-3 rounded-xl" [class]="bgColor">
  <span class="block text-xs text-gray-500">{{ titulo | translate }}</span>
  @if (euros) {
    <span class="block text-lg font-medium" [class]="textColor">{{ cantidad | currency:'EUR' }}</span>
  } @else {
    <span class="block text-lg font-medium" [class]="textColor">{{ cantidad | number:'1.0-0' }}</span>
  }
</div>
